var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('h1',{class:`h1-atom is--variant-${_vm.variant}`,attrs:{"itemprop":"headline"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }